import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";
import Home from "./Pages/Home/Home";
import "react-toastify/dist/ReactToastify.min.css";
function App() {
  return (
    <div className="max-w-[1550px] mx-auto">
      <Navbar></Navbar>

      <Routes>
        <Route path="/" element={<Home />}></Route>
      </Routes>

      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
